module.exports = __webpack_public_path__ + "static/media/logoBBC.8a9f560e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/logoBBC.svg
// module id = 188
// module chunks = 0